/** @format */

import { Component, Input, Output, EventEmitter, inject } from '@angular/core';

import { PopoverController, IonList, IonItem, IonIcon, IonText } from '@ionic/angular/standalone';

export interface PopoverAction {
  icon: string;
  text: string;
  tooltip?: string;
  type: string; // used for click handler
  disabled?: boolean; // default: false
  color?: string; // e.g. delete
}

@Component({
    selector: 'app-action-popover',
    templateUrl: './action-popover.component.html',
    styleUrls: ['./action-popover.component.scss'],
    standalone: true,
    imports: [IonList, IonItem, IonIcon, IonText]
})
export class ActionPopoverComponent {
  private popoverCtrl = inject(PopoverController);

  @Input() actions: PopoverAction[];
  @Input() dismissOnEmit = false;
  /** note that media breakpoint will hide it too */
  @Input() showText = true;
  @Output() selected = new EventEmitter<string>();

  onClick(actionType) {
    this.selected.emit(actionType);
    if (this.dismissOnEmit) {
      this.popoverCtrl.dismiss({ selected: actionType });
    }
  }
}
